import { render, staticRenderFns } from "./treatment-total.vue?vue&type=template&id=0087aa2f&"
import script from "./treatment-total.vue?vue&type=script&lang=js&"
export * from "./treatment-total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports